export const isShowBackDrop = (state =false, action) => {
    switch (action.type) {
        case "isShowBackDrop_update": return action.payload; 
        default: return state;
    }
}